<div class="squarredModal" style=" z-index: 10501 !important;">
    <div class="chat-container-ai">
        <div class="chat-messages-ai" #chatBox>
            <div *ngFor="let msg of messages" [ngClass]="msg.role" class="chat-bubble-ai">
                <ng-container *ngIf="msg.type === 'list'; else plainText">
                    <div class="editor-list">
                        <div class="editor-card" *ngFor="let editor of msg.data" (click)="redirectToResource(editor.id)">
                            <!-- <img src="https://via.placeholder.com/40" alt="avatar" class="editor-avatar" /> -->
                            <pre>
                                <div class="editor-info">
                                <div class="editor-name">{{ editor.firstName }} {{ editor.lastName }}</div>
                                <div class="editor-function">{{ editor.function }}</div>
                                <div class="editor-function">{{ editor.skillDescription }}</div>
                            </div>
                            </pre>
                        </div>
                    </div>
                </ng-container>

                <!-- For regular messages -->
                <ng-template #plainText>
                    <pre>{{ msg.content }}</pre>
                </ng-template>
            </div>
        </div>

        <div class="chat-input-ai">
            <div class="input-wrapper input-field-ai">
                <input type="text" class="input-box" placeholder="Type your message..." [(ngModel)]="userInput"
                    (keydown.enter)="sendMessage()">
                <span class="underline"></span>
            </div>

            <button class="border-0" (click)="sendMessage()" title="{{'Send' | translate}}">
                <mat-icon>send</mat-icon>
            </button>
        </div>
    </div>
</div>